import "core-js/modules/es7.array.includes.js";
import Vue from 'vue';
var requestIdleCallback = window.requestIdleCallback || function (cb) {
  var start = Date.now();
  return setTimeout(function () {
    cb({
      didTimeout: false,
      timeRemaining: () => Math.max(0, 50 - (Date.now() - start))
    });
  }, 1);
};
var cancelIdleCallback = window.cancelIdleCallback || function (id) {
  clearTimeout(id);
};
var observer = window.IntersectionObserver && new window.IntersectionObserver(entries => {
  entries.forEach(_ref => {
    var {
      intersectionRatio,
      target: link
    } = _ref;
    if (intersectionRatio <= 0) {
      return;
    }
    link.__prefetch();
  });
});
export default {
  name: 'NuxtLink',
  extends: Vue.component('RouterLink'),
  props: {
    prefetch: {
      type: Boolean,
      default: true
    },
    noPrefetch: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (this.prefetch && !this.noPrefetch) {
      this.handleId = requestIdleCallback(this.observe, {
        timeout: 2e3
      });
    }
  },
  beforeDestroy() {
    cancelIdleCallback(this.handleId);
    if (this.__observed) {
      observer.unobserve(this.$el);
      delete this.$el.__prefetch;
    }
  },
  methods: {
    observe() {
      // If no IntersectionObserver, avoid prefetching
      if (!observer) {
        return;
      }
      // Add to observer
      if (this.shouldPrefetch()) {
        this.$el.__prefetch = this.prefetchLink.bind(this);
        observer.observe(this.$el);
        this.__observed = true;
      }
    },
    shouldPrefetch() {
      return this.getPrefetchComponents().length > 0;
    },
    canPrefetch() {
      var conn = navigator.connection;
      var hasBadConnection = this.$nuxt.isOffline || conn && ((conn.effectiveType || '').includes('2g') || conn.saveData);
      return !hasBadConnection;
    },
    getPrefetchComponents() {
      var ref = this.$router.resolve(this.to, this.$route, this.append);
      var Components = ref.resolved.matched.map(r => r.components.default);
      return Components.filter(Component => typeof Component === 'function' && !Component.options && !Component.__prefetched);
    },
    prefetchLink() {
      if (!this.canPrefetch()) {
        return;
      }
      // Stop observing this link (in case of internet connection changes)
      observer.unobserve(this.$el);
      var Components = this.getPrefetchComponents();
      for (var Component of Components) {
        var componentOrPromise = Component();
        if (componentOrPromise instanceof Promise) {
          componentOrPromise.catch(() => {});
        }
        Component.__prefetched = true;
      }
    }
  }
};